<script setup lang="ts">
import { useId } from 'vue'

const { modelValue } = defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ 'update:modelValue': [boolean] }>()

const id = useId()

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.checked)
}
</script>

<template>
  <div :class="$style.root">
    <input :class="$style.checkbox" type="checkbox" :id="id" :value="modelValue" @change="onChange" />
    <label :class="$style.label" :for="id"> Send as BBCode </label>
  </div>
</template>

<style lang="scss" module>
.root {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.checkbox {
  width: 16px;
  height: 16px;
  accent-color: #4a8dff;
  appearance: auto;
  margin: 0 !important;
}

.label {
  font-size: 14px;
  font-weight: 400 !important;
  margin-bottom: 0 !important;
}
</style>
